import React, { useState, useEffect, useRef } from 'react';
import Logo from '../../../temp2docWebSite/src/assets/images/temp2doc-logo.svg';
import { trackButtonClick, trackNavigation } from '../analytics';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isPdfToolsDropdownOpen, setIsPdfToolsDropdownOpen] = useState(false);
  const [mobilePdfToolsOpen, setMobilePdfToolsOpen] = useState(false);
  const pdfToolsDropdownRef = useRef(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    trackButtonClick("mobile_menu_toggle", mobileMenuOpen ? "close" : "open", "navigation");
  };

  const handleMobileLinkClick = (section, label) => {
    setMobileMenuOpen(false);
    trackNavigation(section, label);
  };

  const togglePdfToolsDropdown = () => {
    setIsPdfToolsDropdownOpen((prev) => !prev);
  };

  const navigate = (path) => {
    window.location.href = path;
  };

  const toggleMobilePdfTools = () => {
    const next = !mobilePdfToolsOpen;
    setMobilePdfToolsOpen(next);
    trackButtonClick("mobile_pdf_tools_toggle", next ? "open" : "close", "navigation");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        pdfToolsDropdownRef.current &&
        !pdfToolsDropdownRef.current.contains(e.target)
      ) {
        setIsPdfToolsDropdownOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsPdfToolsDropdownOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <nav className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <div className="flex items-center">
            <a href="/" className="flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded">
              <img src={Logo} alt="Temp2Doc" className="h-9 w-auto" style={{ minWidth: 25, minHeight: 25 }} />
            </a>
            {/* PDF Tools Dropdown (near logo) */}
            <div className="relative hidden md:block ml-2" ref={pdfToolsDropdownRef}>
              <button 
                onClick={togglePdfToolsDropdown}
                className="text-gray-700 hover:text-primary-600 px-3 py-2 nav-text-small font-medium transition-colors inline-flex items-center"
              >
                Free PDF Tools
                <svg className={`ml-1 w-4 h-4 transition-transform ${isPdfToolsDropdownOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {/* PDF Tools Dropdown Menu */}
              {isPdfToolsDropdownOpen && (
                <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/chat-with-pdf');
                    }}
                  >
                    Chat PDF With AI
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/merge-pdf');
                    }}
                  >
                    Merge PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/split-remove-rotate-pdf');
                    }}
                  >
                    Split Remove Rotate PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-word');
                    }}
                  >
                    PDF to Word
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-excel');
                    }}
                  >
                    PDF to Excel
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-image');
                    }}
                  >
                    PDF to Image
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/pdf-to-powerpoint');
                    }}
                  >
                    PDF to PowerPoint
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/protect-pdf');
                    }}
                  >
                    Protect PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/unlock-pdf');
                    }}
                  >
                    Unlock PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/transform-pdf');
                    }}
                  >
                    Repair & Transform PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/compress-pdf');
                    }}
                  >
                    Compress PDF
                  </button>
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setIsPdfToolsDropdownOpen(false);
                      navigate('/diagnose-pdf');
                    }}
                  >
                    Verify & Diagnose PDF
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            >
              <span className="sr-only">Open main menu</span>
              {mobileMenuOpen ? (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <button
              className="block w-full text-left py-2 px-3 text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-primary-600 rounded-md"
              onClick={toggleMobilePdfTools}
            >
              <div className="flex justify-between items-center">
                <span>Free PDF Tools</span>
                <svg
                  className={`w-5 h-5 transition-transform ${mobilePdfToolsOpen ? 'rotate-180' : ''}`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </button>
            
            {mobilePdfToolsOpen && (
              <div className="pl-4 space-y-1">
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'chat_with_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/chat-with-pdf');
                  }}
                >
                  Chat PDF With AI
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'merge_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/merge-pdf');
                  }}
                >
                  Merge PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'split_remove_rotate_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/split-remove-rotate-pdf');
                  }}
                >
                  Split Remove Rotate PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'pdf_to_word');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/pdf-to-word');
                  }}
                >
                  PDF to Word
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'pdf_to_excel');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/pdf-to-excel');
                  }}
                >
                  PDF to Excel
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'pdf_to_image');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/pdf-to-image');
                  }}
                >
                  PDF to Image
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'pdf_to_powerpoint');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/pdf-to-powerpoint');
                  }}
                >
                  PDF to PowerPoint
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'protect_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/protect-pdf');
                  }}
                >
                  Protect PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'unlock_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/unlock-pdf');
                  }}
                >
                  Unlock PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'transform_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/transform-pdf');
                  }}
                >
                  Repair & Transform PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'compress_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/compress-pdf');
                  }}
                >
                  Compress PDF
                </button>
                <button
                  className="block w-full text-left py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    trackNavigation('pdf_tools', 'diagnose_pdf');
                    setMobileMenuOpen(false);
                    setMobilePdfToolsOpen(false);
                    navigate('/diagnose-pdf');
                  }}
                >
                  Verify & Diagnose PDF
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
